import { Bar, mixins } from 'vue-chartjs'
import moment from 'moment'
import ApiLocalStorage from 'src/helpers/ApiLocalStorage'

export default Bar.extend({
  mixins: [mixins.reactiveData],
  data () {
    return {}
  },
  props: {
    range: '',
    url: '',
    time: '',
    localName: '',
    addMonths: {
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    type_from: {
      type: String,
      default: ''
    }
  },
  computed: {
    lic () {
      return this.$store.getters.lic
    }
  },
  mounted () {
    this.renderChart(this.chartData,
      {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              categoryPercentage: 1,
              barPercentage: 0.6,
              gridLines: {
                display: true,
                color: 'rgba(0,0,0,0.1)',
                borderDash: [6, 3]
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                color: 'rgba(0,0,0,0.1)',
                display: true,
                borderDash: [6, 3]
              }
            }]
        }
      })
  },
  watch: {
    range: function () {
      if (this.range[0] !== null || this.range[1] !== null) {
        this.getData(moment(this.range[0]).format('YYYY-MM-DD'), moment(this.range[1]).format('YYYY-MM-DD'))
      }
    },
    lic: function () {
      if (this.range[0] !== null || this.range[1] !== null) {
        this.getData(moment(this.range[0]).format('YYYY-MM-DD'), moment(this.range[1]).format('YYYY-MM-DD'))
      }
    }
  },
  methods: {
    fillData (keys, exe, online, sum) {
      this.chartData = {
        labels: keys,
        datasets: [
          {
            label: 'Instalacyjna',
            backgroundColor: '#9ad0f5',
            data: exe,
            borderColor: '#51B4E5',
            borderWidth: 2
          },
          {
            label: 'Online',
            backgroundColor: '#ffa1ab',
            data: online,
            borderColor: '#EE5A63',
            borderWidth: 2
          },
          {
            label: 'Suma instalacyjna + online',
            data: sum,
            borderColor: '#41b883',
            borderWidth: 2,
            type: 'line'
          }
        ]
      }
    },
    getData (startDate, endDate) {
      this.$emit('loader', true)
      if (startDate <= endDate) {
        ApiLocalStorage.requestData(this.localName + startDate + ',' + endDate + this.lic, this.url, 'post', {
          'lic': this.lic,
          'period': startDate + ',' + endDate,
          'months': this.addMonths,
          'type': this.type,
          'type_from': this.type_from
        }, this.time).then((data) => {
          this.fillData(data.keys, data.values.exe, data.values.online, this.sumExeOnline(data))
          this.$nextTick(() => {
            this.$emit('loader', false)
          })
        })
      }
    },
    sumExeOnline (data) {
      let sum = []
      for (let i = 0; i < data.values.exe.length; i++) {
        sum[i] = (data.values.exe[i] + data.values.online[i]).toFixed(2)
      }
      return sum
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/UIComponents/Charts/BarChart.js